
export * from '../../frontend-taglib-clay/__liferay__/exports/@clayui$toolbar.js';

import __default__ from '../../frontend-taglib-clay/__liferay__/exports/@clayui$toolbar.js';
export default __default__;
